//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { IScheduledInstagramPost } from '@apis/universal-posts/scheduled-posts/universalScheduledPostsApiModel';
import { getFilteredPosts } from '@instagram-account/redux/schedule/selectors/getFilteredPosts';
import DateString from '@models/DateString';
import TimeZoneId from '@models/TimeZoneId';
import { getUserTimeZone } from '@redux/selectors/getUserTimeZone';

/**
 * Determines the appropriate date string for the post in the scheduled posts
 * list that is scheduled the furthest in the future, assuming the posts are
 * already stored in the proper order. Returns undefined if there
 * are no posts scheduled.
 */
export const getDateOfLatestPostImpl = (
  scheduledPosts: IScheduledInstagramPost[],
  tz: TimeZoneId,
) => {
  const lastPost = scheduledPosts.slice(-1)[0];

  return lastPost
    ? DateString.fromTimestamp(lastPost.scheduledTime, tz)
    : undefined;
};

export const getDateOfLatestPost = createSelector(
  getFilteredPosts,
  getUserTimeZone,
  getDateOfLatestPostImpl,
);
